export default __webpack_public_path__ + "assets/images/github.634fee7.png";